import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const accountService = {
  get_me: async (token) => {
    const response = await https.get(`${API_ROUTES.ACCOUNT.GET_INFO}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  update: (formData, token) => {
    return https.put(`${API_ROUTES.ACCOUNT.GET_INFO}`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
